module.exports = ".fs-11{\n    font-size: 11px;\n}\n.profile-link{\n     cursor:pointer;\n     color:blue;\n     text-decoration:underline;\n}\n.error-msg{\n    font-size: 12px;\n    margin-left: 16px;\n    color: red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/nick-name/nick-name.component.css
// module id = ./src/app/feature/main/roles-shared/components/nick-name/nick-name.component.css
// module chunks = main